import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { SendInvoiceContainerComponent } from './send-invoice-container';
export const SendInvoiceRoute: Ng2StateDeclaration = {
    name: 'qbsendinvoices',
    url: '/qbsendinvoices',
    data: { requiresAuth: true },
    // loadChildren: () => import('./send-invoice/send-invoice.module').then(r => r.SendInvoiceModule)
    component: SendInvoiceContainerComponent
};
